import { Card, theme, Typography } from "kosmos-ui/lib";

import { useLayout } from "app/context/LayoutContext/hooks";
import { TEAM } from "app/constants";
import { GithubIcon, LinkedInIcon } from "app/assets/icons";

import {
  TeamSectionContainer,
  TeamContainer,
  TeamMemberSocialMediaContainer,
  TeamMemberAvatarImg,
  TeamMemberHeader,
  TeamMemberSubheader,
} from "./styles";

export default function TeamSection() {
  const { mobile } = useLayout();

  return (
    <TeamSectionContainer>
      <Typography
        as="h1"
        variant="title1"
        style={{ color: theme.colorsPalette.white.default }}
      >
        El equipo
      </Typography>

      <Typography variant="paragraph1" style={{ maxWidth: 760 }}>
        Somos un equipo multidisciplinario. Ingenieros, publicistas, directores
        de arte, comunicadores audiovisuales, auditores. Talentos muy
        diferentes, con una idea en común: una app que trabaje para impulsar a
        emprendedores y marcas independientes.
      </Typography>

      <TeamContainer>
        {TEAM.map((member, index) => {
          return (
            <Card
              key={index}
              style={{
                padding: mobile ? "30px 28px" : "30px 50px",
                alignItems: "center",
                backgroundColor: theme.colorsPalette.black.light,
              }}
            >
              <TeamMemberAvatarImg src={member.avatar} />

              <TeamMemberHeader>{member.name}</TeamMemberHeader>

              <TeamMemberSubheader>{member.role}</TeamMemberSubheader>

              {member.experience}

              {member.socialMedia && (
                <TeamMemberSocialMediaContainer>
                  {member.socialMedia.linkedIn && (
                    <a
                      href={member.socialMedia.linkedIn}
                      style={{ marginRight: member.socialMedia.github ? 8 : 0 }}
                    >
                      <LinkedInIcon variant="gradient" height="16px" />
                    </a>
                  )}

                  {member.socialMedia.github && (
                    <a href={member.socialMedia.github}>
                      <GithubIcon variant="gradient" height="16px" />
                    </a>
                  )}
                </TeamMemberSocialMediaContainer>
              )}
            </Card>
          );
        })}
      </TeamContainer>
    </TeamSectionContainer>
  );
}
